import React from "react"; // eslint-disable-line
import { Link } from "react-router-dom";
import constants from "../../constants";
import i18n from "../../i18n";

class ErrorItem extends React.Component {
    constructor(props) {
        super(props);
        this.getLink = this.getLink.bind(this);
    }

    getLink(link, id) {
        if (id === undefined || id === null || id === "") {
            return `/projects/${this.props.projectId}/${link}`;
        }
        return `/projects/${this.props.projectId}/${link}/${id}`;
    }

    formatUrl(url) {
        // eslint-disable-next-line no-param-reassign
        url = url.replace("-", " ");
        // eslint-disable-next-line no-param-reassign
        url = url.replace("/", " > ");
        // eslint-disable-next-line no-param-reassign
        url = this.toTitleCase(url);

        return url;
    }

    // eslint-disable-next-line class-methods-use-this
    toTitleCase(str) {
        return str.replace(/\w\S*/g, (txt) => {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    }

    render() {
        const { error, id, pagesFlag, projectId } = this.props;

        // Update error message conditionally
        if (error.errorTypeString === "MODS_ERR_NOMODULESENABLED" && pagesFlag) {
            error.errorMessage = "One module or menu item must be enabled";
        }
        // Extract configError once
        const configError = constants.ConfigErrorCode.find(
            (m) => m.ErrorCode === error.errorTypeString
        );

        // Extract pageId and pageTitle from comment
        let pageId = "";
        let pageTitle = "";
        let errorMessage = error.errorMessage;
        let formatUrl = this.formatUrl(configError.Link);

        if (error.comment && error.comment.includes(" | ")) {
            const parts = error.comment.split(" | ");
            pageId = parts[0]?.trim() || "";
            pageTitle = parts[1]?.trim() || "";
            formatUrl = `${this.toTitleCase(configError.DisplayName)} > ${this.toTitleCase(pageTitle)}`;
        }
       
        let moduleLink = this.getLink(configError.Link, pageId);
        const showFixButton = configError?.Link && configError.Link !== "";

        return (
            <div
                data-qa={`error-${error.errorTypeString}`}
                id={`error-${id}`}
                className="error-item"
            >
                {showFixButton && (
                    <div
                        data-qa={`error-${id}-name`}
                        id={`error-${id}-name`}
                        className="error-item__name"
                    >
                        {formatUrl}
                    </div>
                )}

                <div
                    data-qa={`error-${id}-description`}
                    id={`error-${id}-description`}
                    className="error-item__description"
                >
                    {errorMessage}
                </div>

                {showFixButton && (
                    <div
                        data-qa={`error-${id}-button`}
                        id={`error-${id}-button`}
                        className="error-item__action"
                    >
                        <Link
                            to={moduleLink}
                            className="btn btn-sq btn-sm btn-dark"
                        >
                            {i18n.t("fix")}
                        </Link>
                    </div>
                )}
            </div>
        );
    }

}

export default ErrorItem;
